import { PageLoader } from "apps/commons/components/PageLoader";
import { usePartnerMarketingApi } from "apps/partnerMarketing/usePartnerMarketingApi";
import { Outlet } from "react-router";

const Layout = () => {
    const { isLoading } = usePartnerMarketingApi();

    if (isLoading) return <PageLoader />;

    return <Outlet />;
};

export default Layout;
